import { render } from "./PendingSignup.vue?vue&type=template&id=5de4a206"
import script from "./PendingSignup.vue?vue&type=script&lang=js"
export * from "./PendingSignup.vue?vue&type=script&lang=js"
script.render = render

export default script